// removed by extract-text-webpack-plugin
module.exports = {"msg-wrapper":"msg-wrapper","message-status":"message-status","message-tag":"message-tag","more-history":"more-history","content":"content","message-item":"message-item","name":"name","message-text":"message-text","message-img":"message-img","msg-img":"msg-img","message-right":"message-right","inner-card-outer":"inner-card-outer","inner-card":"inner-card","file-icon":"file-icon","file-size":"file-size","content-img":"content-img","content-title":"content-title","content-des":"content-des"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/message.scss
// module id = qj7u
// module chunks = 1